import { faUtensils } from '@fortawesome/pro-regular-svg-icons/faUtensils';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { faVideo } from '@fortawesome/pro-regular-svg-icons/faVideo';
import { faBook } from '@fortawesome/pro-regular-svg-icons/faBook';
import { faMap } from '@fortawesome/pro-regular-svg-icons/faMap';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faArrowProgress } from '@fortawesome/pro-regular-svg-icons/faArrowProgress';
import { faAddressCard } from '@fortawesome/pro-regular-svg-icons/faAddressCard';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';

// ─── Environment Variables ───────────────────────────────────────────
export const WEEKS_LIST_SLUG = process.env.WEEKS_LIST_SLUG;
export const ONBOARD_CONTENT_ID = process.env.ONBOARD_CONTENT_ID;
export const ACTION_HOURS_ID = process.env.ACTION_HOURS_ID;
export const SOCIAL_PLUS_API_KEY = process.env.WLC_SOCIAL_PLUS_API_KEY;

// ─── Product Identifiers ────────────────────────────────────────────
export const PRODUCT_SLUG = 'wlc';
export const PRODUCT_ID = 1;

// ─── Social / Community ─────────────────────────────────────────────
export const DEFAULT_COMMUNITY_IDS = [
  '6954b00035f676c595aa0ffc',
  '6954acdd35f676c595a9c727',
  '695489f2352024d244b4837e',
  '6954670208e97199d5f9762f',
  '69545ff45bf09671ded4fc73',
  '69545cb0352024d244ae9375',
  '6954516d2251ed7f7f64b582',
  '69543e3f4a81c60527c33c69'
];

export const AMITY_EXCLUDES = [
  'community_profile_page/community_header/community_category',
  '*/*/copy_link_button',
  '*/*/clipsfeed_button'
];

export const AMITY_CONFIGS = {
  excludes: AMITY_EXCLUDES,
  preferred_theme: 'light'
};

// ─── Floating Chat ──────────────────────────────────────────────────
export const WELLNESS_BUDDY_FLOW_ID = process.env.WLC_WELLNESS_BUDDY_FLOW_ID || '849b572d-c933-4212-96ca-7667e1257c2f';

export const FLOATING_CHAT_SUGGESTIONS = [
  'What are healthy breakfast options?',
  'How can I improve my sleep quality?',
  'What exercises are best for beginners?',
  'How do I meal prep for the week?'
];

// ─── Navigation ─────────────────────────────────────────────────────
export const NAV_ITEMS = [
  { name: 'Weekly Guide', longText: 'Your Weekly Guide', typeOfComponent: null, slug: '', icon: faMap },
  { name: 'Recipes', longText: 'All Recipes', typeOfComponent: 'RecipesGrid', slug: 'recipes', icon: faUtensils },
  {
    name: 'Live Events',
    longText: 'Live Events',
    typeOfComponent: 'ExternalLink',
    slug: 'https://frn.co/wlc-zoom-hub',
    icon: faCalendar
  },
  { name: 'Forum', longText: 'Forum', typeOfComponent: null, slug: 'community', icon: faUsers },
  { name: 'Favorites', longText: 'Favorites Library', typeOfComponent: null, slug: 'favorites-library', icon: faHeart },
  { name: 'Resources', longText: 'All Resources', typeOfComponent: null, slug: 'resources', icon: faBook },
  { name: 'Action Hours', longText: 'All Action Hours', typeOfComponent: null, slug: 'action-hours', icon: faVideo },
  {
    name: 'Track',
    longText: 'Health Track Planner',
    typeOfComponent: null,
    slug: 'current-track',
    icon: faArrowProgress,
    iconStyles: { transform: 'scale(1, -1)' }
  }
];

// ─── Route Slugs ────────────────────────────────────────────────────
export const LIVE_CALLS_SLUG = 'wlc-live-calls-2024';
export const COMMUNITY_GUIDELINES_SLUG = 'wlc-community-guidelines';
export const EVENT_SLUG = 'wlc-calendar-of-events';
